import { Link } from "react-router-dom";
import Layout from "../shared/Layout";

export default function NotFound() {
  return (
    <Layout>
      <div className="h-full flex flex-col justify-center min-h-80 gap-4">
        <h1 className="font-semibold text-xl">404 - Page Not Found</h1>
        <p>The page you are looking for does not exist.</p>
        <Link className="btn w-60" to="/">Go back to the homepage</Link>
      </div>
    </Layout>
  );
}
